<!-- HERO SECTION -->
<section class="hero-section">

  <picture class="hero-bg">
    <source type="image/jpeg" srcset="assets/dspace/images/banner.jpg">
    <img src="assets/dspace/images/banner.jpg" alt="Uttara University Campus">
  </picture>

  <div class="hero-overlay"></div>

  <div class="container hero-content">
    <div class="row align-items-center">
      <div class="">

        <span class="badge hero-badge mb-3">
          Academic Excellence • Open Access • Global Reach
        </span>

        <h1 class="hero-title">
          UU Academic Repository
        </h1>

        <p class="hero-description">
          Discover, preserve, and share the scholarly achievements of
          Uttara University’s faculty, researchers, and students —
          accessible to the world.
        </p>

        <div class="hero-actions mt-4">

          <a [routerLink]="['/community-list']" class="btn btn-primary">
            Explore Collections
          </a>

          <a href="mailto:library@uttarauniversity.edu.bd" class="btn btn-outline-light">
            Submission Support
          </a>

        </div>

        <!-- Subtle Text Link Below -->
        <div class="library-link mt-3">
          <a href="https://www.library.uttara.ac.bd" target="_blank" rel="noopener">
            Visit Uttara University Library Website
          </a>
        </div>

        <div class="hero-features mt-5">
          <div class="feature-item">
            <i class="fas fa-database"></i>
            <span>Preserved Research</span>
          </div>

          <div class="feature-item">
            <i class="fas fa-globe"></i>
            <span>Global Open Access</span>
          </div>

          <div class="feature-item">
            <i class="fas fa-shield-alt"></i>
            <span>Permanent Archiving</span>
          </div>
        </div>

      </div>
    </div>
  </div>

  <small class="credits">
    © Uttara University
  </small>

</section>

<!-- NEXT SECTION EXAMPLE -->
<section class="section-spacing">
  <div class="container">
    <!-- Your next content -->
  </div>
</section>